import { render, staticRenderFns } from "./PayoutsHistory.vue?vue&type=template&id=6c791de1&scoped=true&"
import script from "./PayoutsHistory.vue?vue&type=script&lang=ts&"
export * from "./PayoutsHistory.vue?vue&type=script&lang=ts&"
import style0 from "./PayoutsHistory.vue?vue&type=style&index=0&id=6c791de1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c791de1",
  null
  
)

export default component.exports